//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import { CampaignsStateFactory } from '@campaigns/routes/stateFactory';

import {
  componentNameToTemplate,
  hasFeature,
} from 'app/initialization/routing/stateHelpers';

export const contentSourceStates = {
  'campaigns.content-source': CampaignsStateFactory({
    url: '/content-source',
    data: {
      hasAccess: () => hasFeature(FeatureNames.ContentSource),
      title: 'Campaigns: ContentSource',
    },
    views: {
      main: {
        template: componentNameToTemplate('campaignsContentSourceOverviewPage'),
      },
    },
  }),

  'campaigns.content-source-available-reviews': CampaignsStateFactory({
    url: '/content-source/available-reviews',
    data: {
      hasAccess: () => hasFeature(FeatureNames.ContentSource),
      title: 'Campaigns: ContentSource Available Reviews',
    },
    views: {
      main: {
        template: componentNameToTemplate(
          'campaignsContentSourceAvailableReviewsPage',
        ),
      },
    },
  }),

  'campaigns.content-source-orders': CampaignsStateFactory({
    url: '/content-source/orders',
    data: {
      hasAccess: () => hasFeature(FeatureNames.ContentSource),
      title: 'Campaigns: ContentSource Orders',
    },
    views: {
      main: {
        template: componentNameToTemplate('campaignsContentSourceOrdersPage'),
      },
    },
  }),

  'campaigns.content-source-order-details': CampaignsStateFactory({
    url: '/content-source/orders/:orderId',
    data: {
      hasAccess: () => hasFeature(FeatureNames.ContentSource),
      title: 'Campaigns: ContentSource Order Details',
    },
    views: {
      main: {
        template: componentNameToTemplate(
          'campaignsContentSourceOrderDetailsPage',
        ),
      },
    },
  }),
};
